import React, { useEffect, useState } from 'react';
import MaintenanceMessage from './maintenance_message';
import LoadingSpinner from './loading_spinner';

// FallbackComponent: omit it for the default maintenance banner (right for full-page
// surfaces); pass an explicit `null` to render nothing (right for small widgets embedded
// in otherwise-working V1 pages); or pass your own component. Note the JS default only
// applies to `undefined`, so the explicit `null` is a real opt-out.
function withV2HealthCheck(WrappedComponent, FallbackComponent = MaintenanceMessage) {
  return function HealthCheckWrapper(props) {
    // null = pending, true = passed, false = failed
    const [healthState, setHealthState] = useState(null);

    useEffect(() => {
      const v2HealthCheck = async () => {
        try {
          if (window?.v2HealthCheck) {
            const passed = await window.v2HealthCheck();
            setHealthState(passed === true);
          } else {
            // eslint-disable-next-line no-console
            console.warn('window.v2HealthCheck not found, assuming health check passes');
            setHealthState(true);
          }
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error('Health check failed:', error);
          setHealthState(false);
        }
      };

      v2HealthCheck();
    }, []);

    if (healthState === null) {
      // A null fallback opts out of the spinner here as well as the failure banner below,
      // so embedded widgets don't flash a page-sized spinner while the check is in flight.
      return FallbackComponent ? <LoadingSpinner /> : null;
    }

    if (!healthState) {
      return FallbackComponent ? <FallbackComponent /> : null;
    }

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <WrappedComponent {...props} />;
  };
}

export default withV2HealthCheck;
